import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { TextField } from "@mui/material";
import { Field } from "react-final-form";

function FormDateField({
  name,
  id,
  label,
  inputFormat,
  value,
  handleChange
}: {
  name: string;
  id: string;
  label: string;
  inputFormat: string;
  value: Date | null;
  handleChange: (value: Date) => void;
}) {
  return (
    <Field name={name} parse={(value) => formatDateTime(value)} type="date">
      {({ input, meta: { touched, invalid, error } }) => (
        <DateInput
          {...input}
          id={id}
          label={label}
          inputFormat={inputFormat}
          value={value}
          error={touched && invalid}
          helperText={touched && error}
          onChange={handleChange}
        />
      )}
    </Field>
  );
}

export default FormDateField;

function DateInput(props: any) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        {...props}
        maxDate={new Date()}
        renderInput={(params: any) => {
          return <TextField {...params} variant="filled" />;
        }}
      />
    </LocalizationProvider>
  );
}

export const formatDateTime = (input: any) => {
  if (!input || (input instanceof Date && Number.isNaN(input.getTime())))
    return "";
  if (typeof input === "string") {
    return input;
  }
  return format(input, "dd/MM/yyyy");
};
